import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()
        this.url = process.env.REACT_APP_KECLOACK_URL
        this.globalUrl = process.env.REACT_APP_BASE_URL
    }

    loginUser(userName, password) {
        let formData = new URLSearchParams()

        formData.append("username", userName)
        formData.append("password", password)

        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET)
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(resolve).catch(reject)
        })

    }

    getAccessInfo(token) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/admins/access-information`,
                {},
                {
                    "Authorization": this.httpClient.convertToken(token),
                    'Content-Type': "application/json"
                }
            ).then(resolve).catch(reject)
        })
    }

    sendVerificationCode(username, password, key) {

        return new Promise((resolve, reject) => {

            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            )
                .post(
                    `presentation/admins/otp/sms`,
                    {
                        "username": username,
                        "password": password
                    }
                )
                .then(resolve).catch(reject)
        })
    }

    sendOtpSmsForgetPassword(phoneNumber, nationalCode) {
        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/json", process.env.REACT_APP_BASE_URL)
                .post(
                    "presentation/otp/sms",
                    {
                        "phoneNumber": phoneNumber,
                        "nationalCode": nationalCode,
                        "otpKind": "ADMIN"
                    }
                ).then(resolve).catch(reject)
        })
    }

    updateForgotPassword(nationalCode, newPassword, phoneNumber, otp) {
        let formData = new URLSearchParams()

        formData.append("nationalCode", nationalCode)
        formData.append("phoneNumber", phoneNumber)
        formData.append("newPassword", newPassword)
        formData.append("otp", otp)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }

        return new Promise((resolve, reject) => {
            new HttpClient(
                config,
                'application/x-www-form-urlencoded'
            ).post("presentation/admins/password/reset", formData
            ).then(resolve).catch(reject)
        })
    }
}